/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_One_ScheduleInputs */

const en_for_whom_tag_one_schedule = /** @type {(inputs: For_Whom_Tag_One_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One schedule`)
};

const pl_for_whom_tag_one_schedule = /** @type {(inputs: For_Whom_Tag_One_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden grafik`)
};

/**
* | output |
* | --- |
* | "One schedule" |
*
* @param {For_Whom_Tag_One_ScheduleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_one_schedule = /** @type {((inputs?: For_Whom_Tag_One_ScheduleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_One_ScheduleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_one_schedule(inputs)
	return en_for_whom_tag_one_schedule(inputs)
});